import {ApiConfig} from '@api/configs';

export interface ConfigState extends ApiConfig {
    changePriceGroupTo?: string;
}

export const initialConfigState = (): ConfigState | {} => {
  return { };
};
